import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    limitReachedToast: string;
    limitReachedToastDated: ({ date }: {
        date: string;
    }) => string;
    partialLimitTitle: string;
    partialLimitBody: ({ remaining, attempted }: {
        remaining: number;
        attempted: number;
    }) => string;
    partialLimitDismiss: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast shown when the account has no generations left and no reset date is known. */
            limitReachedToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useFireflyRateLimit.limitReachedToast?c=rd3y127sxyfr", defaultMessage: "You''ve hit your generation limit for now \u2014 check back later." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast shown when the account has no generations left, dated with the reset day. */
            limitReachedToastDated: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ date }: {
                        date: string;
                    }): string => __intl__.intl().formatMessage({ id: "useFireflyRateLimit.limitReachedToastDated?c=32ak1t47i1tx0", defaultMessage: "You''ve hit your generation limit \u2014 try again after {date}." }, { date: date }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title of the "reduce your selection" dialog (some remaining, but not enough). */
            partialLimitTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useFireflyRateLimit.partialLimitTitle?c=1uj3q7eqfzpwr", defaultMessage: "Not enough generations remaining" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Body explaining how many remain vs. how many the selection needs. */
            partialLimitBody: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ remaining, attempted }: {
                        remaining: number;
                        attempted: number;
                    }): string => __intl__.intl().formatMessage({ id: "useFireflyRateLimit.partialLimitBody?c=18obnc1a6yfbm", defaultMessage: "You have {remaining, plural, one {{remaining, number} generation} other {{remaining, number} generations}} remaining, but this selection would use {attempted, number}. Reduce your selection and try again." }, { remaining: remaining, attempted: attempted }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dismiss button for the "reduce your selection" dialog. */
            partialLimitDismiss: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useFireflyRateLimit.partialLimitDismiss?c=26ns0v4lhnziz", defaultMessage: "Got it" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
